export default "__VITE_ASSET__$qtnbyr1__"